import { render, staticRenderFns } from "./OrganisationDetails.vue?vue&type=template&id=742984d8&"
import script from "./OrganisationDetails.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports